import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PrintService {
  private printModeSubject = new BehaviorSubject<boolean>(false);

  public setPrintMode(isPrintMode: boolean): void {
    this.printModeSubject.next(isPrintMode);
  }

  public get printMode$(): Observable<boolean> {
    return this.printModeSubject.asObservable();
  }
}
